import { render } from "./PageAccount.vue?vue&type=template&id=5537f114"
import script from "./PageAccount.vue?vue&type=script&lang=js"
export * from "./PageAccount.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__